/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Coded by www.creative-tim.com
=========================================================
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

function StatusCell({ icon, color }) { // Elimina `status` de los parámetros
    return (
      <SoftBox display="flex" alignItems="center">
        <SoftBox mr={1}>
          <SoftButton
            variant="outlined"
            color={color}
            size="small"
            iconOnly
            circular
          >
            <Icon sx={{ fontWeight: 'bold' }}>{icon}</Icon>
          </SoftButton>
        </SoftBox>
        {/* Elimina el SoftTypography que muestra el valor de `status` */}
      </SoftBox>
    );
  }
  
  // Actualiza las PropTypes para eliminar `status`
  StatusCell.propTypes = {
    icon: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  };

export default StatusCell;
